import { HttpClient } from './HttpClient.js';


export const CalendarService = {
    
    async getCalendar(id, mes, anio) {
        return await HttpClient.get(`/calendario/get-information/${id}/${mes}/${anio}`).then(response => response);
    }


}